/* @flow */
import Collection from 'lib/Collection';
import Device from 'entities/Device';

class Devices extends Collection {
  initialize() {
    this.url = '/devices';
    this.model = Device;
  }

  // $FlowFixMe
  type(type) {
    return this.models.filter((model) => model.getType() === type);
  }

  enabled() {
    return this.models.filter(model => model.isEnabled());
  }
}

export default Devices;



// WEBPACK FOOTER //
// ./src/collections/Devices.js